import axios from 'axios';
import AppConfig from "../../../../config/AppConfig";
function getBaseURL() {
	return AppConfig.mingti_server
}

const instance = axios.create({
  baseURL: getBaseURL() + '/admin/'
});

instance.interceptors.request.use(function (config) {
  if(!config.params) config.params = {}
  config.params.login_name = localStorage.getItem('login')
  config.params.token = localStorage.getItem('token')
  return config;
});

instance.defaults.transformRequest = [function (data) {
  let src = ''
  for (let item in data) {
    src += encodeURIComponent(item) + '=' + encodeURIComponent(data[item]) + '&'
  }
  return src
}]

function getImagePath(path) {
  return getBaseURL() + path
}

const User = {

  getList(params, callback) {
    instance.get('user/getList', {params: params}).then(resp => {
      callback(resp.data)
    })
  },

  save(data, callback) {
    instance.post('user/save', data).then(resp => {
      callback(resp.data)
    })
  },

  delete(id, callback) {
    instance.post('user/delete', {id: id}).then(resp => {
      callback(resp.data)
    })
  }

}

const UserGroup = {

  getList(callback) {
    instance.get('usergroup/getList').then(resp => {
      callback(resp.data)
    })
  }

}

const Card = {

  getList(params, callback) {
    instance.get('card/getList', {params: params}).then(resp => {
      callback(resp.data)
    })
  },


}

const Article = {

  getList(params, callback) {
    instance.get('article/getList', {params: params}).then(resp => {
      callback(resp.data)
    }).catch(resp => {
      callback(resp.data)
    })
  },

  getUploadUrl() {
    return getBaseURL() + '/admin/article/uploadPic'
  },

  getUploadFile() {
    return getBaseURL() + '/admin/article/uploadFile'
  },

  save(data, callback) {
    instance.post('article/save', data).then(resp => {
      callback(resp.data)
    }).catch(resp => {
      callback(resp.data)
    })
  }

}
function postUpload(url=null,file) {
  return axios({
    url: url||Article.getUploadFile(),
    method: 'post',
    data: file,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export {
  getBaseURL,
  getImagePath,
  User,
  UserGroup,
  Card,
  Article,
  instance,
  postUpload
}



// WEBPACK FOOTER //
// ./src/components/Admin/App/Card/common.js